import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  View,
  StyleSheet,
  TouchableOpacity,
  Dimensions,
  ScrollView,
} from "react-native";
import { web } from "../../accessories/Platform";
import CustomText from "../../accessories/CustomText";
import {
  IconButton,
  InputBox,
  ModalButton,
  Separator,
  Title,
  context,
} from "../../accessories/accessories";
import {
  WrappedTextView,
  handleAPI,
  handleOpenScanDocFile,
  log,
} from "../../accessories/CommonFunctions";
import ArrowSpinner from "../../accessories/ArrowSpinner";
import Dropdown from "../../accessories/DropDown";
import { removeDuplicates } from "../../accessories/CommonFunctions";
import MaterialIcons from "react-native-vector-icons/MaterialIcons";
import { REDIRECT_URL } from "@env";
import { useDropzone } from "react-dropzone";

const DocumentViewer = (props) => {
  const { contextDetails, setContextDetails } = useContext(context); //Get value from context

  const {
    handleToggleDrawer = () => {},
    handleAPIGetLoanDetails = () => {},
    handleSelectFileDocView = () => {},
    handleUnSavedFileStatus = () => {},
    processingStatus: iProcessingStatus,
    documentArray = [],
  } = props;

  const [documentDetails, setDocumentDetails] = useState(null),
    [processingStatus, setProcessingStatus] = useState(null),
    [existDocumentArray, setExistDocumentArray] = useState(null),
    [parentDocumentDetails, setParentDocumentDetails] = useState([]),
    [acceptedFiles, setAcceptedFiles] = useState(null),
    [queryStringDetails, setQueryStringDetails] = useState({}),
    [editDetails, setEditDetails] = useState({ isVisible: !true }),
    [additionalBorrowerInfo, setAdditionalBorrowerInfo] = useState([]),
    [additionalEmploymentInfo, setAdditionalEmploymentInfo] = useState([]),
    [additionalBankInfo, setAdditionalBankInfo] = useState([]),
    [loanData, setLoanData] = useState({}),
    [isSaving, setIsSaving] = useState(false),
    [borrowerOption, setBorrowerOption] = useState(null),
    [employerOption, setEmployerOption] = useState(null),
    [bankOption, setBankOption] = useState(null);
  const [entityTypeList, setEntityTypeList] = useState({
    borrowerEntityTypeList: [2],
    borrowerEmployerEntityTypeList: [6],
    bankEntityTypeList: [7],
    loanEntityTypeList: [1, 17],
  });
  const {
    borrowerEmployerEntityTypeList,
    borrowerEntityTypeList,
    bankEntityTypeList,
    loanEntityTypeList,
  } = entityTypeList;

  useEffect(() => {
    if (documentArray.length > 0) {
      setExistDocumentArray(documentArray);
    } else {
      setExistDocumentArray(null);
    }
  }, [documentArray]);

  useEffect(() => {
    if (Object.keys(queryStringDetails).length > 0) {
      handleAPI({
        name: "GetLoanAppWizard",
        params: {
          LoanId: queryStringDetails["LoanId"],
          SessionId: queryStringDetails["SessionId"],
          btnflag: 0,
        },
      })
        .then((response) => {
          response = response.split("~");

          if (response[0] != "" && response[0] != null) {
            let loanData_ = JSON.parse(response[0])[0];
            setLoanData(loanData_);
          }

          if (response[8] != "" && response[8] != null)
            setAdditionalBorrowerInfo(JSON.parse(response[8]) || []);

          if (response[11] != "" && response[11] != null)
            setAdditionalBankInfo(JSON.parse(response[11]));

          if (response[12] != "" && response[12] != null)
            setAdditionalEmploymentInfo(JSON.parse(response[12]));
        })
        .catch((err) => console.log("Error from GetLoanAppWizard ====> ", err));
    }
  }, [queryStringDetails]);

  const prePare = async () => {
    const LoanId = Number(props["LoanId"]),
      SessionId = props["SessionId"],
      ScanDocId = Number(props["ScanDocId"]),
      docId = Number(props["doctype"]),
      iEntityId = Number(props["iiEntityId"]),
      EntityTypeId = Number(props["EntityTypeId"]);

    if (LoanId) {
      setQueryStringDetails({ LoanId, SessionId, ScanDocId, docId, iEntityId });
      setParentDocumentDetails(props["iEditUploadDetails"]);
      let SecureDocResult = "",
        JsonFileList = [],
        SplitSecureResult = [],
        jsonObj = [];

      if (existDocumentArray.length > 0) {
        jsonObj = existDocumentArray;
      } else {
        SecureDocResult = await handleGetSecureDoc(LoanId);

        SplitSecureResult = SecureDocResult.split("~");
        jsonObj =
          SplitSecureResult[1].length > 0
            ? JSON.parse(SplitSecureResult[1])
            : [];
      }

      if (borrowerEmployerEntityTypeList.includes(EntityTypeId)) {
        JsonFileList = jsonObj.filter(
          ({
            ScanDocId: fScanDocId,
            Scandoctype,
            iEntityId: fEntityId,
            iRecId: fRecId,
            UseDoc,
          }) =>
            fScanDocId &&
            UseDoc === 2 &&
            Scandoctype === docId &&
            ([169].includes(Number(docId)) || [16].includes(EntityTypeId)
              ? fEntityId
              : fRecId) == iEntityId
        );
      } else if (
        [...borrowerEntityTypeList, ...bankEntityTypeList].includes(
          EntityTypeId
        )
      ) {
        JsonFileList = jsonObj.filter(
          ({
            ScanDocId: fScanDocId,
            Scandoctype,
            iEntityId: fEntityId,
            iRecId: fRecId,
            UseDoc,
          }) =>
            fScanDocId &&
            UseDoc === 2 &&
            Scandoctype === docId &&
            ([772, 373].includes(docId) ||
            ([88, 62].includes(docId) && EntityTypeId == 2)
              ? fRecId
              : fEntityId) == iEntityId
        );
      } else if (loanEntityTypeList.includes(EntityTypeId)) {
        JsonFileList = jsonObj.filter(
          ({ ScanDocId: fScanDocId, Scandoctype, UseDoc }) =>
            fScanDocId && UseDoc === 2 && Scandoctype === docId
        );
      }

      JsonFileList = JsonFileList.sort(
        (a, b) => b["ScanDocId"] - a["ScanDocId"]
      );
      JsonFileList = JsonFileList || [];
      setDocumentDetails(JsonFileList);
      setProcessingStatus(null);
      if (JsonFileList.length == 0) {
        handleToggleDrawer(false);
      }
    }
  };

  useEffect(() => {
    try {
      if (contextDetails?.cacheDocDetails) {
        setDocumentDetails(
          contextDetails?.cacheDocDetails?.documentDetails || []
        );
        setQueryStringDetails(
          contextDetails?.cacheDocDetails?.queryStringDetails
        );
        setParentDocumentDetails(
          contextDetails?.cacheDocDetails?.parentDocumentDetails
        );
      } else if (existDocumentArray !== null) {
        prePare();
      }
    } catch (e) {}
    if (iProcessingStatus === "cancelConfirmation") {
      setProcessingStatus(iProcessingStatus || null);
    }
  }, [props, existDocumentArray, entityTypeList]);

  useEffect(() => {
    handleUnSavedFileStatus((acceptedFiles || []).length > 0);
  }, [acceptedFiles]);

  const handleGetOptionDetails = async () => {
    handleAPI({
      name: "GetBorEmpBankOptions",
      params: {
        LoanId: props["LoanId"],
      },
    })
      .then(async (response) => {
        response = JSON.parse(response);

        response.forEach((item) => {
          let key = Object.keys(item)[0];
          item[key].forEach((object, index) => {
            object.label = object.label.trim() || key + " " + (index - 1);
            return object;
          });
        });

        setBorrowerOption(response[0]["Borrower"]);
        setAdditionalBorrowerInfo(response[0]["Borrower"].slice(2, 99));
        setEmployerOption(response[1]["Employer"]);
        setAdditionalEmploymentInfo(response[1]["Employer"].slice(2, 99));
        setBankOption(response[2]["Bank"]);
        setAdditionalBankInfo(response[2]["Bank"].slice(2, 99));

        const { EntityList } = response[3];

        setEntityTypeList(() => {
          return {
            borrowerEmployerEntityTypeList: JSON["parse"](
              EntityList[0]["label"]
            ).map((val) => Number(val)),
            borrowerEntityTypeList: JSON["parse"](EntityList[1]["label"]).map(
              (val) => Number(val)
            ),
            bankEntityTypeList: JSON["parse"](EntityList[2]["label"]).map(
              (val) => Number(val)
            ),
            loanEntityTypeList: JSON["parse"](EntityList[3]["label"]).map(
              (val) => Number(val)
            ),
          };
        });

        let { iAcceptedFiles = [], iEditUploadDetails } = props;
        if (iAcceptedFiles.length) {
          setAcceptedFiles(iAcceptedFiles);
          setEditDetails(iEditUploadDetails);
        }
      })
      .catch((err) =>
        console.log("Error from GetBorEmpBankOptions ====> ", err)
      );
  };
  useEffect(() => {
    (async () => {
      if (props["LoanId"] > 0) {
        await handleGetOptionDetails();
      }
    })();
  }, [props["LoanId"]]);

  const handleCancelEdit = async () => {
    if ((acceptedFiles || []).length) {
      setProcessingStatus("cancelConfirmation");
    } else {
      setEditDetails({ ...editDetails, isVisible: false });
    }
  };

  const handleGetSecureDoc = async (LoanId) => {
    return await handleAPI({
      name: "GetSecureDoc",
      params: { LoanId },
    })
      .then((response) => {
        return response;
      })
      .catch((e) => console.log("Error from GetSecureDoc ====> ", e));
  };

  const handleOpenFile = async (docId) => {
    let url = await handleOpenScanDocFile(
      queryStringDetails["SessionId"],
      docId,
      queryStringDetails["LoanId"]
    );

    if (web) {
      if (window.location.host.indexOf("localhost") !== -1)
        url = url.replace("../../../", REDIRECT_URL);
      window.open(
        url,
        "_blank",
        "width=750,height=780,resizable=1,scrollbars=1"
      );
    } else {
      url = url.replace("../../../", REDIRECT_URL);
      setContextDetails((prevContextDetails) => {
        return {
          ...prevContextDetails,
          cacheDocDetails: {
            documentDetails,
            queryStringDetails,
            parentDocumentDetails,
          },
        };
      });
      props.navigation.navigate("Pdf", {
        url,
        backTo: "Home",
        GoToNav: 9,
        isNeedBack: true,
        onBack: () => {
          handleToggleDrawer(true);
        },
      });
    }
    handleToggleDrawer(false);
  };
  const handleResetState = () => {
    log("States are cleared in", "Doc Viewer");
    setDocumentDetails(null);
    setQueryStringDetails({});
    setEditDetails({ isVisible: !true });
    setAdditionalBorrowerInfo([]);
    setAdditionalEmploymentInfo([]);
    setAdditionalBankInfo([]);
    setLoanData({});
    setIsSaving(false);
    setBorrowerOption([
      { value: 0, label: "Select" },
      { value: 1, label: "Add New" },
    ]);
    setEmployerOption([
      { value: 0, label: "Select" },
      { value: 1, label: "Add New" },
    ]);
    setBankOption([
      { value: 0, label: "Select" },
      { value: 1, label: "Add New" },
    ]);
  };
  const UploadButton = () => {
    return !web ? (
      <ModalButton
        onPress={() => {
          //handleSelectFileDocView();
          //handleDirectUpload();
          handleDirectMobileUpload();
        }}
        icon={
          <View style={{ marginBottom: -3 }}>
            <MaterialIcons name="photo-library" color="#fff" size={16} />
          </View>
        }
        title="  Upload Additional Document"
        textStyle={{
          alignSelf: "flex-end",
          minHeight: 25,
          marginBottom: -3,
        }}
        style={{
          borderRadius: 50,
          marginBottom: 10,
          paddingHorizontal: 30,
          paddingVertical: 25,
          alignSelf: "center",
          backgroundColor: "#295B9A",
        }}
      />
    ) : (
      <UploadButtonWeb />
    );
  };
  const handleDirectMobileUpload = () => {
    const directUploadDetails = {
      ...parentDocumentDetails,
      ientityId:
        parentDocumentDetails.ientityId ||
        (bankEntityTypeList.includes(parentDocumentDetails.EntityTypeId)
          ? bankOption && bankOption.length > 1
            ? bankOption[1].value
            : 1
          : 1),
      iRecId:
        parentDocumentDetails.iRecId ||
        (borrowerOption && borrowerOption.length > 1
          ? borrowerOption[1].value
          : 1),
      skipDrawer: true, // Flag to skip drawer
    };

    // Set edit details to trigger direct save
    setEditDetails(directUploadDetails);
    handleSelectFileDocView();
  };
  const UploadButtonWeb = () => {
    const onDrop = useCallback((acceptedFiles) => {
      handleSaveEditDetails(acceptedFiles, parentDocumentDetails);
      return;
      const { EntityTypeId } = parentDocumentDetails,
        isDirectSave =
          (borrowerEntityTypeList.includes(EntityTypeId) &&
            borrowerOption.length >= 3) ||
          (bankEntityTypeList.includes(EntityTypeId) &&
            bankOption.length >= 3) ||
          loanEntityTypeList.includes(EntityTypeId);
      true; // Always skip drawer for uploaded tab

      if (isDirectSave) {
        const directUploadDetails = {
          ...parentDocumentDetails,
          ientityId:
            parentDocumentDetails.ientityId ||
            (bankEntityTypeList.includes(parentDocumentDetails.EntityTypeId)
              ? bankOption && bankOption.length > 1
                ? bankOption[1].value
                : 1
              : 1),
          iRecId:
            parentDocumentDetails.iRecId ||
            (borrowerOption && borrowerOption.length > 1
              ? borrowerOption[1].value
              : 1),
        };
        handleSaveEditDetails(acceptedFiles, directUploadDetails);
        //handleSaveEditDetails(acceptedFiles, parentDocumentDetails);
      } else {
        setAcceptedFiles(acceptedFiles);
        setEditDetails(parentDocumentDetails);
      }
    }, []);

    const { getRootProps, getInputProps } = useDropzone({ onDrop });

    return (
      <div
        {...getRootProps()}
        style={{
          borderWidth: 1,
          borderRadius: 50,
          marginBottom: 10,
          alignSelf: "center",
          backgroundColor: "#295B9A",
          alignContent: "center",
          display: "grid",
          cursor: "pointer",
          padding: "10px 30px",
        }}
      >
        <input {...getInputProps()} />
        <CustomText
          style={{
            color: "#fff",
            alignSelf: "center",
            justifySelf: "center",
            paddingVertical: 8,
            display: "flex",
          }}
          bold={true}
        >
          <MaterialIcons name="photo-library" color="#fff" size={16} /> Upload
          Additional Document
        </CustomText>
      </div>
    );
  };

  const handleDirectUpload = () => {
    const directUploadDetails = {
      ...parentDocumentDetails,
      ientityId:
        parentDocumentDetails.ientityId ||
        (bankEntityTypeList.includes(parentDocumentDetails.EntityTypeId)
          ? bankOption && bankOption.length > 1
            ? bankOption[1].value
            : 1
          : 1),
      iRecId:
        parentDocumentDetails.iRecId ||
        (borrowerOption && borrowerOption.length > 1
          ? borrowerOption[1].value
          : 1),
    };

    handleSelectFileDocView();
    // Force direct save by setting accepted files and calling save directly
    setTimeout(() => {
      handleSaveEditDetails(null, directUploadDetails);
    }, 100);
  };
  const GetEditScreen = () => {
    let { docId, ientityId, iRecId, EntityTypeId } = editDetails,
      employerValue = 0;

    if (bankEntityTypeList.includes(EntityTypeId)) {
      employerValue =
        ientityId > 0
          ? ientityId
          : additionalEmploymentInfo.length === 0
          ? 1
          : null;
    } else {
      employerValue =
        ientityId > 0 && docId !== 169
          ? ientityId
          : additionalEmploymentInfo.length === 0
          ? 1
          : null;
    }
    if (
      (bankEntityTypeList.includes(EntityTypeId)
        ? bankOption
        : employerOption
      ).filter((item) => item.value == ientityId).length == 0
    ) {
      ientityId = -99;
    }

    return (
      <>
        <Separator />
        <ScrollView
          showsVerticalScrollIndicator={false}
          showsHorizontalScrollIndicator={false}
        >
          <View>
            {[
              ...borrowerEmployerEntityTypeList,
              ...borrowerEntityTypeList,
            ].includes(EntityTypeId) && (
              <View>
                <Title
                  text="Which borrower is this for?"
                  style={{ marginBottom: 15, fontSize: web ? 24 : 18 }}
                />
                <Dropdown
                  isValid={true}
                  label="Borrower"
                  options={borrowerOption}
                  value={editDetails["iRecId"]}
                  onSelect={(item) => {
                    setEditDetails({
                      ...editDetails,
                      iRecId: parseInt(item["value"]),
                    });
                  }}
                  isMap={true}
                  // disabled={docId == 772 || docId == 213 || docId == 253}
                />
                {editDetails["iRecId"] === 1 && (
                  <View>
                    <InputBox
                      validate={!(editDetails["firstName"] || "")}
                      label="First Name"
                      placeholder="First Name"
                      onChangeText={(text) => {
                        setEditDetails({ ...editDetails, firstName: text });
                      }}
                      value={(editDetails["firstName"] || "")?.toString()}
                    />
                    <InputBox
                      validate={!(editDetails["lastName"] || "")}
                      label="Last Name"
                      placeholder="Last Name"
                      onChangeText={(text) => {
                        setEditDetails({ ...editDetails, lastName: text });
                      }}
                      value={(editDetails["lastName"] || "")?.toString()}
                    />
                  </View>
                )}
              </View>
            )}
            {bankEntityTypeList.includes(EntityTypeId) && (
              <>
                <View>
                  <Title
                    text={`Which bank is this for?`}
                    style={{ marginBottom: 15, fontSize: web ? 24 : 18 }}
                  />
                  <Dropdown
                    isValid={true}
                    label="Bank"
                    options={bankOption}
                    value={ientityId}
                    onSelect={(item_) => {
                      setEditDetails({
                        ...editDetails,
                        ientityId: item_["value"],
                      });
                    }}
                    isMap={true}
                    // disabled={docId == 43}
                  />
                  {editDetails["ientityId"] == 1 && (
                    <InputBox
                      validate={!(editDetails["BankName"] || "")}
                      label="Bank Name"
                      placeholder="Bank Name"
                      onChangeText={(text) => {
                        setEditDetails({ ...editDetails, BankName: text });
                      }}
                      value={(editDetails["BankName"] || "")?.toString()}
                    />
                  )}
                </View>
              </>
            )}
            {borrowerEmployerEntityTypeList.includes(EntityTypeId) && (
              <>
                <View>
                  <Title
                    text={`Which Employer is this for?`}
                    style={{
                      marginBottom: 15,
                      fontSize: web ? 24 : 18,
                    }}
                  />

                  <Dropdown
                    isValid={true}
                    label="Employer"
                    options={employerOption}
                    value={editDetails["ientityId"]}
                    onSelect={(item) => {
                      console.log(
                        'parseInt(item["value"])',
                        parseInt(item["value"])
                      );
                      setEditDetails({
                        ...editDetails,
                        ientityId: parseInt(item["value"]),
                      });
                    }}
                    isMap={true}
                  />
                  {editDetails["ientityId"] === 1 && (
                    <InputBox
                      validate={!(editDetails["employerName"] || "")}
                      label="Employer Name"
                      placeholder="Employer Name"
                      onChangeText={(text) => {
                        try {
                          setEditDetails({
                            ...editDetails,
                            employerName: text,
                          });
                        } catch (e) {
                          log("Error from  ====> ", e);
                        }
                      }}
                      value={(editDetails["employerName"] || "")?.toString()}
                    />
                  )}
                </View>
              </>
            )}

            <View
              style={{
                flexDirection: "row",
                alignSelf:
                  processingStatus === "cancelConfirmation"
                    ? "flex-start"
                    : "flex-end",
              }}
            >
              {isSaving && (
                <View style={{ flexDirection: "row" }}>
                  <ArrowSpinner
                    style={{ height: 22, alignSelf: "flex-end" }}
                    size={20}
                  />
                  <CustomText style={{ fontSize: 14, alignSelf: "flex-end" }}>
                    {" "}
                    File is Uploading...{"     "}
                  </CustomText>
                </View>
              )}

              {processingStatus === "cancelConfirmation" && web && (
                <View style={{ flexDirection: "column" }}>
                  <View>
                    <Title
                      style={{ fontSize: web ? 22 : 18 }}
                      text="Are you sure you want to Cancel?"
                    />
                  </View>
                  <View style={{ flexDirection: "row" }}>
                    <IconButton
                      buttonType="secondary"
                      title="No"
                      onPress={async () => {
                        setProcessingStatus(null);
                      }}
                      style={{ marginRight: 15 }}
                    />
                    <IconButton
                      title="Yes"
                      onPress={async () => {
                        setAcceptedFiles(null);
                        setEditDetails({ ...editDetails, isVisible: false });
                        setProcessingStatus(null);
                      }}
                      style={{ marginRight: 5 }}
                    />
                  </View>
                </View>
              )}
              {(processingStatus !== "cancelConfirmation" || !web) && (
                <>
                  <IconButton
                    buttonType="secondary"
                    title="Cancel"
                    onPress={handleCancelEdit}
                    style={{ marginRight: 15 }}
                  />
                  <IconButton
                    title="Save"
                    onPress={() => {
                      setProcessingStatus(null);
                      setIsSaving(true);
                      handleSaveEditDetails();
                    }}
                  />
                </>
              )}
            </View>
          </View>
        </ScrollView>
      </>
    );
  };

  const handleSaveEditDetails = async (
    iAcceptedFiles = acceptedFiles,
    iUploadDetails = editDetails,
    isClose
  ) => {
    setProcessingStatus("uploadingFile");
    let {
      docId,
      ientityId,
      iRecId,
      firstName,
      lastName,
      employerName,
      EntityTypeId,
      BankName,
    } = iUploadDetails || editDetails;

    if (
      (bankEntityTypeList.includes(EntityTypeId)
        ? bankOption
        : employerOption
      ).filter((item) => item.value == ientityId).length == 0
    ) {
      ientityId = -99;
    }

    if (borrowerEmployerEntityTypeList.includes(EntityTypeId)) {
      let WhichBorrower = loanData["UserId"],
        WhichEntity = loanData["Employer_name"];

      if (iRecId) {
        WhichBorrower =
          iRecId > 1
            ? iRecId
            : await handleSaveAdditionalInfo(
                -99,
                [
                  {
                    FirstName: firstName || "Borrower First",
                    LastName: lastName || "Borrower Last",
                  },
                ],
                0,
                "Borrower"
              );
      }

      WhichEntity =
        ientityId > 1
          ? ientityId
          : await handleSaveAdditionalInfo(
              -11,
              [
                {
                  Empmt_Emp_Name: employerName || "Employer",
                  CustId: WhichBorrower,
                },
              ],
              WhichBorrower,
              "Employer"
            );

      handleSaveUploadedFiles(
        WhichEntity,
        WhichBorrower,
        docId,
        isClose,
        iAcceptedFiles,
        iUploadDetails
      );
    }

    if (bankEntityTypeList.includes(EntityTypeId)) {
      let WhichBorrower = loanData["UserId"],
        WhichEntity = 0;

      if (iRecId) {
        WhichBorrower =
          iRecId > 1
            ? iRecId
            : await handleSaveAdditionalInfo(
                -99,
                [
                  {
                    FirstName: firstName || "Borrower First",
                    LastName: lastName || "Borrower Last",
                  },
                ],
                0,
                "Borrower"
              );
      }

      WhichEntity =
        ientityId > 1
          ? ientityId
          : await handleSaveAdditionalInfo(
              -33,
              [{ Bank_Name: BankName || "Bank", AccType: 0 }],
              WhichBorrower,
              "Bank"
            );

      handleSaveUploadedFiles(
        WhichEntity,
        WhichBorrower,
        docId,
        isClose,
        iAcceptedFiles,
        iUploadDetails
      );
    }

    if (
      [...borrowerEntityTypeList, ...loanEntityTypeList].includes(EntityTypeId)
    ) {
      let WhichBorrower = loanData["UserId"],
        WhichEntity = 0;
      if (iRecId) {
        WhichBorrower =
          iRecId > 1
            ? iRecId
            : await handleSaveAdditionalInfo(
                -99,
                [
                  {
                    FirstName: firstName || "Borrower First",
                    LastName: lastName || "Borrower Last",
                  },
                ],
                0,
                "Borrower"
              );
      }
      handleSaveUploadedFiles(
        WhichEntity,
        WhichBorrower,
        docId,
        isClose,
        iAcceptedFiles,
        iUploadDetails
      );
    }
  };

  const handleSaveAdditionalInfo = async (
    flag,
    InputJSON,
    CustId = 0,
    type
  ) => {
    // console.log("InputJSON", { flag, InputJSON, CustId });
    return await handleAPI({
      name: "SaveAdditionalInfo",
      params: {
        CustId,
        LoanId: queryStringDetails["LoanId"],
        InputJSON: JSON.stringify(InputJSON || {}),
        flag: flag,
        SessionId: queryStringDetails["SessionId"],
      },
    })
      .then((CustId) => {
        handleGetOptionDetails();
        handleAPIGetLoanDetails();
        CustId = Number(CustId);
        let key = "iRecId";
        if (type === "Borrower") {
          key = "iRecId";
          const { FirstName, LastName } = InputJSON[0],
            option = {
              value: CustId,
              label: `${FirstName} ${LastName}`,
            };
          setBorrowerOption((prevBorrowerOption) => {
            return [...prevBorrowerOption, option];
          });
        } else if (type === "Employer") {
          key = "ientityId";
          const { Empmt_Emp_Name } = InputJSON[0],
            option = {
              value: CustId,
              label: Empmt_Emp_Name,
            };
          setEmployerOption((prevEmployerOption) => {
            return [...prevEmployerOption, option];
          });
        } else if (type === "Bank") {
          key = "ientityId";
          const { Bank_Name } = InputJSON[0],
            option = {
              value: CustId,
              label: Bank_Name,
            };
          setBankOption((prevBankOption) => {
            return [...prevBankOption, option];
          });
        }

        setEditDetails({
          ...editDetails,
          [key]: parseInt(CustId),
        });
        return CustId;
      })
      .catch((e) => console.log("Error from SaveAdditionalInfo ====>", e));
  };
  const handleSaveUploadedFiles = (
    iEntityId,
    iRecId,
    DocTypeId,
    isClose = true,
    fileList,
    iUploadDetails
  ) => {
    const iAcceptedFiles = acceptedFiles || fileList,
      iEditDetails = { ...editDetails, ...iUploadDetails };

    let details = {
        LoanId: queryStringDetails["LoanId"],
        sessionid: queryStringDetails["SessionId"],
        DocTypeId,
        entityid: iEntityId || iEditDetails["ientityId"] || 0,
        iRecId: iRecId || iEditDetails["iRecId"] || 0,
        Category: iEditDetails["Category"] || 0,
        description: iEditDetails["Descript"] || "",
        usedoc: iEditDetails["UseDoc"] || 2,
        entitytypeid: iEditDetails["EntityTypeId"] || 0,
        conditonid: 0,
      },
      index = 1;

    if (iAcceptedFiles) {
      iAcceptedFiles.forEach(async (file) => {
        let formData = new FormData();
        if (web) formData.append("", file);
        else
          formData.append("file_attachment", {
            uri: file.uri,
            name: file.name || "ScannedImage.jpg",
            type: file.mimeType || "image/jpg",
          });

        let requestOptions = {
          method: "POST",
          body: formData,
          redirect: "follow",
        };

        await handleAPI({
          name: "UploadFilesdocs",
          params: details || {},
          requestOptions: requestOptions,
        })
          .then((ScanDocId) => {
            log("Response form UploadFilesdocs", ScanDocId);
            if (ScanDocId)
              handleSaveScanDocDetails(
                ScanDocId,
                iEntityId || iEditDetails["ientityId"] || 0,
                iEditDetails["EntityTypeId"],
                iRecId || iEditDetails["iRecId"] || 0,
                index === iAcceptedFiles.length,
                isClose
              );
            if (index === iAcceptedFiles.length) {
              setAcceptedFiles(null);
            }
            index++;
          })
          .catch((e) => console.error("Error form UploadFilesdocs ====> ", e));
      });
    } else {
      handleSaveScanDocDetails(
        iEditDetails["scandocid"],
        iEntityId,
        iRecId || iEditDetails["iRecId"] || 0,
        true,
        isClose
      );
    }
  };
  const handleSaveScanDocDetails = (
    scandocid,
    ientityid,
    EntityTypeId,
    irecid,
    loadFlag,
    isClose = true
  ) => {
    let xml = `<root><row><scandocid>${scandocid}</scandocid><ientityid>${ientityid}</ientityid><irecid>${irecid}</irecid><ientitytypeid>${EntityTypeId}</ientitytypeid></row></root>`;
    handleAPI({
      name: "savescandocdetails",
      params: { loanid: queryStringDetails["LoanId"], xml: xml },
    })
      .then(async (response) => {
        if (loadFlag) {
          setProcessingStatus("Loading");
          setEditDetails({ ...{}, isVisible: false });
          // prePare();
          setExistDocumentArray([]);
          setIsSaving(false);
          // Add this line to refresh data
          setTimeout(() => {
            handleToggleDrawer(false, true);
          }, 500);
        }
        if (web) {
          try {
            window?.opener?.document
              ?.getElementById("buttonReloadDoc")
              ?.click();
          } catch (error) {}
        }
        // console.log("isClose", isClose);
        handleToggleDrawer(true, true);
      })
      .catch((e) => console.log("Error from savescandocdetails ====> ", e));
  };

  return (
    <>
      <View style={[styles.container]}>
        <ScrollView
          showsVerticalScrollIndicator={false}
          showsHorizontalScrollIndicator={false}
          bounces={false}
          style={{ width: "100%" }}
        >
          <View style={{ width: "100%" }}>
            {editDetails["isVisible"] ? (
              GetEditScreen()
            ) : (
              <>
                <View style={{ marginTop: 10 }}>
                  <UploadButton />
                </View>
                <View
                  style={[
                    {
                      paddingHorizontal: 0,
                      paddingVertical: 10,
                      width: "100%",
                    },
                    !web
                      ? {
                          maxHeight: Dimensions.get("window").height - 300,
                        }
                      : {},
                  ]}
                >
                  <View style={styles.headerContainer}>
                    <CustomText
                      style={[styles.headerText, { width: "55%" }]}
                      bold={true}
                    >
                      Document
                    </CustomText>
                    <CustomText
                      style={[
                        styles.headerText,
                        {
                          width: "45%",
                        },
                      ]}
                      bold={true}
                    >
                      Upload Time
                    </CustomText>
                  </View>
                  {processingStatus === "Loading" &&
                  (documentDetails || []).length === 0 ? (
                    <View
                      style={[
                        styles.row,
                        {
                          paddingHorizontal: 5,
                          paddingVertical: 10,
                          width: "100%",
                          backgroundColor: "#fff",
                          justifyContent: "center",
                        },
                      ]}
                    >
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <ArrowSpinner
                          isSpinner={true}
                          size={25}
                          color="#295b9a"
                          style={{ marginTop: 0 }}
                          duration={1200}
                        />
                        <CustomText> {processingStatus}...</CustomText>
                      </View>
                    </View>
                  ) : documentDetails && documentDetails?.length > 0 ? (
                    <View>
                      {documentDetails.map((item, index) => {
                        return (
                          <View
                            key={index}
                            style={[
                              styles.row,
                              {
                                paddingHorizontal: 5,
                                paddingVertical: 15,
                                width: "100%",
                                backgroundColor:
                                  index % 2 === 0 ? "#F7F7F7" : "#fff",
                              },
                            ]}
                          >
                            <View
                              style={{
                                width: "55%",
                              }}
                            >
                              <CustomText
                                style={[styles.fileName, { flexWrap: "wrap" }]}
                                // bold={true}
                                onPress={() => {
                                  handleOpenFile(item["ScanDocId"]);
                                }}
                              >
                                {WrappedTextView({
                                  text: item["FileName"] || "",
                                  maxLength: web ? 22 : 20,
                                })}
                              </CustomText>
                            </View>
                            <View
                              style={{
                                width: "45%",
                              }}
                            >
                              <CustomText style={[styles.date]}>
                                {item["FormattedDateCreated"]}
                              </CustomText>
                            </View>
                          </View>
                        );
                      })}
                      {["uploadingFile", "Loading"].includes(
                        processingStatus
                      ) && (
                        <View
                          style={[
                            styles.row,
                            {
                              paddingHorizontal: 5,
                              paddingVertical: 10,
                              width: "100%",
                              backgroundColor:
                                documentDetails.length % 2 === 0
                                  ? "#F7F7F7"
                                  : "#fff",
                              justifyContent: "center",
                            },
                          ]}
                        >
                          <View
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <ArrowSpinner
                              isSpinner={true}
                              size={25}
                              color="#295b9a"
                              style={{ marginTop: 0 }}
                              duration={1200}
                            />
                            <CustomText> File is Uploading...</CustomText>
                          </View>
                        </View>
                      )}
                    </View>
                  ) : documentDetails && documentDetails.length == 0 ? (
                    <View>
                      <Separator />
                      <CustomText
                        style={{ fontSize: web ? 18 : 15, alignSelf: "center" }}
                      >
                        No Document Found.
                      </CustomText>
                    </View>
                  ) : (
                    <View
                      style={{
                        textAlign: "center",
                        marginBottom: 20,
                        marginTop: 30,
                        flexDirection: "row",
                        justifyContent: "center",
                      }}
                    >
                      <ArrowSpinner
                        // isSpinner={true}
                        size={web ? 28 : 25}
                        style={{ maxWidth: 40 }}
                      />
                      <CustomText style={{ fontSize: web ? 18 : 15 }}>
                        Loading...
                      </CustomText>
                    </View>
                  )}
                </View>
              </>
            )}
          </View>
          <View
            style={{
              borderBottomWidth: 3,
              borderBottomColor: "black",
              marginTop: editDetails["isVisible"] ? 10 : 0,
            }}
          ></View>
        </ScrollView>
      </View>
      {web && (
        <div
          id="buttonReloadDoc"
          onClick={() => {
            setParentDocumentDetails(
              JSON.parse(
                document
                  .getElementById("buttonReloadDoc")
                  .getAttribute("details")
              )
            );
            prePare();
          }}
        ></div>
      )}
    </>
  );
};
const styles = StyleSheet.create({
  container: {
    ...{
      flex: 1,
      // backgroundColor: "#fff",
      // paddingVertical: 20,
      marginBottom: 20,
      marginLeft: web ? 20 : 0,
      marginRight: web ? 20 : 0,
      // marginTop: web ? 20 : -10,
      alignItems: "center",
      // borderRadius: 5,
      // boxShadow: "3px 7px 10px 4px rgb(0 0 0 / 8%)",
      alignSelf: "center",
      maxHeight: web ? 500 : Dimensions.get("window").height / 2 - 30,
      minHeight: web ? 500 : Dimensions.get("window").height / 2 - 30,
    },
    ...(web
      ? {
          maxWidth: 410,
          minWidth: 410,
          overflow: "hidden",
          flex: "none",
          paddingHorizontal: 20,
        }
      : { width: "100%" }),
  },
  headerContainer: {
    flexDirection: "row",
    width: "100%",
    // marginBottom: 10,
    borderBottomColor: "#cccccc",
    borderBottomWidth: 1,
    paddingBottom: 10,
    justifyContent: "space-around",
  },
  headerText: {
    color: "black",
    // textAlign: "center",
    fontSize: 14,
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    // marginBottom: 15,
    borderBottomColor: "#cccccc",
    borderBottomWidth: 1,
    paddingBottom: 10,
    width: "90%",
  },
  fileName: {
    ...{
      textDecorationLine: "underline",
      textDecorationColor: "#295B9A",
      fontSize: 14,
      color: "#295B9A",
    },
    ...(web ? { cursor: "pointer" } : {}),
  },
  date: {
    fontSize: 14,
    // color: "#45464b",
  },
  author: {
    fontSize: 12,
    color: "#45464b",
    marginTop: 4,
  },
  optionContainer: {
    ...{
      backgroundColor: "#f2f5f8",
      borderRadius: 18,
      paddingVertical: web ? 5 : 3,
      paddingHorizontal: web ? 8 : 0,
      borderColor: "#606060",
      borderWidth: 1,
      marginRight: 5,
      marginTop: 10,
      flexDirection: "row",
    },
    ...(!web ? { width: 70 } : {}),
  },
  optionText: {
    fontSize: 13,
    color: "#787878",
    width: "100%",
    textAlign: "center",
    flex: 1,
    flexShrink: 1,
    paddingHorizontal: 15,
    paddingVertical: 2,
  },
  buttonContainer: {
    backgroundColor: "#3972ca",
    borderRadius: 10,
    paddingVertical: 10,
    paddingHorizontal: 20,
  },
  buttonText: {
    fontSize: 20,
    color: "#fff",
    alignSelf: "center",
  },
  pagefooter: {
    paddingLeft: 20,
    padding: 5,
    backgroundColor: "rgb(48, 126, 204)",
    textAlign: "center",
    color: "rgb(255,255, 255)",
    marginTop: 20,
    marginBottom: 10,
    minWidth: "100%",
  },
});

export default DocumentViewer;
